import { IModel, Model } from './model'
import { IUser, User } from './user'
import { IReference } from './reference'

export interface IStatement extends IModel {
  text: string | null
  meta: StatementMeta | null
  isMetaSet: boolean
}

export class Statement extends Model implements IStatement {
  public text: string | null = null
  public meta: StatementMeta | null = null
  public isMetaSet: boolean = false
}

export class StatementMeta {
  public creator: IUser = new User()
  public numJybes: number = 0
  public isJybed: boolean = false
  public isConsidered: boolean = false
  public isIgnored: boolean = false
  public newTag: string | null = null
  public tags: string[] = []
  public newUrl: string | null = null
  public newDesc: string | null = null
  public references: IReference[] = []
}

export class StatementForm {
  public text: string = ''
  public tag: string = ''
  public tags: string[] = []
  public referenceUrl: string = ''
  public referenceDesc: string = ''
  public references: IReference[] = []
}
